import { inputCls } from "./apUtils";

const FIELDS = [
  ["vendor", "Vendor", "text"], ["invoice_number", "Invoice #", "text"],
  ["amount", "Amount", "number"], ["currency", "Currency", "text"],
  ["invoice_date", "Invoice date", "date"], ["due_date", "Due date", "date"],
];

export function ApDetailForm({ draft, setDraft, locations, suggested }) {
  const set = (k) => (e) => setDraft((d) => ({ ...d, [k]: e.target.value }));
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        {FIELDS.map(([k, label, type]) => (
          <label key={k} className="block">
            <span className="text-[10px] uppercase tracking-[0.15em] text-brand-tertiary">{label}</span>
            <input type={type} step={type === "number" ? "0.01" : undefined} value={draft[k] ?? ""} onChange={set(k)}
              data-testid={`ap-field-${k}`} className={`${inputCls} mt-1`} />
          </label>
        ))}
      </div>
      <label className="block">
        <span className="text-[10px] uppercase tracking-[0.15em] text-brand-tertiary">
          Location {suggested && <span className="normal-case tracking-normal text-brand-muted">· AI suggested {suggested}</span>}
        </span>
        <select value={draft.location || ""} onChange={set("location")} data-testid="ap-field-location" className={`${inputCls} mt-1`}>
          <option value="">Unassigned</option>
          {locations.map((l) => <option key={l} value={l}>{l}</option>)}
        </select>
      </label>
      <label className="block">
        <span className="text-[10px] uppercase tracking-[0.15em] text-brand-tertiary">Description</span>
        <input value={draft.description ?? ""} onChange={set("description")} data-testid="ap-field-description" className={`${inputCls} mt-1`} />
      </label>
      <label className="block">
        <span className="text-[10px] uppercase tracking-[0.15em] text-brand-tertiary">Internal notes</span>
        <textarea rows={2} value={draft.notes ?? ""} onChange={set("notes")} data-testid="ap-field-notes" className={`${inputCls} mt-1`} />
      </label>
    </div>
  );
}
